import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const url = location.pathname.split("/");
let purl = url[2];

if (purl === "undefined") {
  purl = null;
}

export default new Router({
  mode: "history",
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "is-active",
  base: `2023/${purl}`,

  routes: [],
});
